import { jsxs, jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarCard } from "@perxis-auto/ui-kit/lib/components/CarCard";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import "react-i18next";
import "@perxis-auto/ui-kit/lib/components/Typography";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "@perxis-auto/ui-kit/lib/components/Loader";
import "../../../shared/context/constructor.js";
import "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/ui-kit";
import "../../../shared/ui/constructorItem/ConstructorItem.js";
import "clsx";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import { PairBlockButton } from "../../../shared/ui/pairBlockButton/PairBlockButton.js";
const CardActions = memo(function CardActions2({
  isLoading,
  t,
  isCompared,
  toggleComparisonText,
  onComparisonClick,
  onComparisonToggle,
  onComparisonRedirect,
  isFavorite,
  toggleFavoriteText,
  onFavoriteClick,
  onFavoriteToggle,
  onFavoriteRedirect,
  ...props
}) {
  if (isLoading) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Row, { gutter: [18, 0], ...props, children: [
    /* @__PURE__ */ jsx(Col, { flex: "none", children: /* @__PURE__ */ jsx(
      CarCard.ButtonTooltip,
      {
        isActive: isCompared,
        icon: "compare",
        onClick: onComparisonClick,
        hoverableTooltipContent: toggleComparisonText,
        clickableTooltipContent: () => /* @__PURE__ */ jsx(
          PairBlockButton,
          {
            icon: [isCompared ? "minus" : "plus", "forward"],
            onClick: [onComparisonToggle, onComparisonRedirect],
            children: [toggleComparisonText, t("widgets.cardActions.comparison.redirect")]
          }
        ),
        children: t("widgets.cardActions.comparison.label")
      }
    ) }),
    /* @__PURE__ */ jsx(Col, { flex: "none", children: /* @__PURE__ */ jsx(
      CarCard.ButtonTooltip,
      {
        isActive: isFavorite,
        icon: "favorites",
        onClick: onFavoriteClick,
        hoverableTooltipContent: toggleFavoriteText,
        clickableTooltipContent: () => /* @__PURE__ */ jsx(
          PairBlockButton,
          {
            icon: [isFavorite ? "minus" : "plus", "forward"],
            onClick: [onFavoriteToggle, onFavoriteRedirect],
            children: [toggleFavoriteText, t("widgets.cardActions.favorites.redirect")]
          }
        ),
        children: t("widgets.cardActions.favorites.label")
      }
    ) })
  ] });
});
export {
  CardActions
};
